import { useInjection } from 'inversify-react';
import { useTranslation } from 'react-i18next';
import { IProjectDetailsStore } from '../../../../../../__legacy__/modules/projectDetails/projectDetails.store';
import { ProjectStatus } from '../../../../../../__legacy__/modules/projects/projects.model';
import { Plan } from '../../../../../../__legacy__/modules/user/user.store';
import { WorkspaceRole } from '../../../../../../__legacy__/modules/workspaces/workspaces.store';
import { checkAll, IPermissionCheckResult } from '../../../../../permissions/permissionsHelpers';
import { ICurrentWorkspaceStore } from '../../../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { IEditMarkingToolStore } from './EditMarkingTool.store';

interface IEditMarkingToolPermissions {
  canOpenEditMarkingToolModal(): IPermissionCheckResult;
  canChangeName(): IPermissionCheckResult;
  canChangeToolType(): IPermissionCheckResult;
  canChangeColor(): IPermissionCheckResult;
}

export const useEditMarkingToolPermissions = (): IEditMarkingToolPermissions => {
  const { t } = useTranslation();
  const { currentWorkspace } = useInjection(ICurrentWorkspaceStore.$);
  const editStore = useInjection(IEditMarkingToolStore.$);
  const projectDetailsStore = useInjection(IProjectDetailsStore.$);

  const canOpenEditMarkingToolModal = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free],
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer],
      currentWorkspace,
      t
    );
  };

  const canChangeName = (): IPermissionCheckResult => {
    if (projectDetailsStore.status === ProjectStatus.Published) {
      return checkAll([Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free], [WorkspaceRole.Owner, WorkspaceRole.Manager], currentWorkspace, t);
    }

    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free],
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer],
      currentWorkspace,
      t
    );
  };

  const canChangeToolType = (): IPermissionCheckResult => {
    if (editStore.isUsed) {
      return { allowed: false, reason: t('cannot_change_tool_type_when_tool_is_used') };
    }

    if (projectDetailsStore.status === ProjectStatus.Published) {
      return checkAll([Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free], [WorkspaceRole.Owner, WorkspaceRole.Manager], currentWorkspace, t);
    }

    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free],
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer],
      currentWorkspace,
      t
    );
  };

  const canChangeColor = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free],
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer],
      currentWorkspace,
      t
    );
  };

  return {
    canOpenEditMarkingToolModal,
    canChangeName,
    canChangeToolType,
    canChangeColor,
  };
};
